import ScalarComboboxOptions_vue_vue_type_script_setup_true_lang_default from "./ScalarComboboxOptions.vue.script.js";
//#region src/components/ScalarCombobox/ScalarComboboxOptions.vue
var ScalarComboboxOptions_default = ScalarComboboxOptions_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarComboboxOptions_default as default };

//# sourceMappingURL=ScalarComboboxOptions.vue.js.map